import request from '@/utils/request'

// 查询计件工资-CC列表
export async function apiDailySalaryList (data) {
  return request({
    url: '/inv/invEmployeeSalaryCc/dailySalaryList',
    method: 'post',
    data
  })
}

// 查询计件工资-CC列表
export async function apiMonthSalaryList (data) {
  return request({
    url: '/inv/invEmployeeSalaryCc/monthSalaryList',
    method: 'post',
    data
  })
}

// 导出计件工资-CC列表
export async function apiExportDailySalaryList (data) {
  return request({
    url: '/inv/invEmployeeSalaryCc/exportDailySalary',
    method: 'post',
    data
  })
}

// 导出计件工资-CC列表
export async function apiExportMonthSalaryList (data) {
  return request({
    url: '/inv/invEmployeeSalaryCc/exportMonthSalary',
    method: 'post',
    data
  })
}

// 刷新-工人MO日计件工资列表
export async function apiRefreshDailySalary (data) {
  return request({
    url: '/inv/invEmployeeSalaryCc/refleshDailySalary',
    method: 'post',
    data
  })
}

// 修改-工人MO日计件工资
export async function apiUpdateDailySalary (data) {
  return request({
    url: '/inv/invEmployeeSalaryCc/modifyDailySalary',
    method: 'post',
    data
  })
}
